export default __webpack_public_path__ + "static/media/tquido-rounded.209af74b.png";